import React from 'react'

const HighlightText = ({text, fontSize}) => {
  return (
    <span className={`font-bold text-pink-500 text-${fontSize}`}>{" "} {text} {" "}</span>
  )
}

export default HighlightText